var navigation = (function() {
    // Mobile navigation


    // If submenu has no children remove from DOM
    $(".mobile-menu-popout .submenu").each(function() {
        if($(this).children().length == 0) {
            $(this).remove();
        }
    })
    // On each mobile menu item
    $(".mobile-menu-popout .mobile-menu-item").each(function() {
        // Find children of submenu
        var submenuChildren = $(this).parent().find(".submenu").children();
        // If submenu has no children
        if(submenuChildren.length == 0) {
            var menuItemHref = $(this).attr("data-href");
            // Remove accessibility attributes
            $(this).removeAttr("aria-haspopup").removeAttr("aria-controls").removeAttr("aria-expanded").removeAttr("aria-label");
            // Add href (to turn into link not button)
            $(this).attr("href", menuItemHref);
        }
    });

    $(".mobile-menu-popout .mobile-menu-item").on("click", function(e) {
        if ($(this).attr("aria-expanded") == "true") {
            $(this).attr("aria-expanded", false);
        } else {
            $(this).attr("aria-expanded", true);
        }
        if ($(this).parent()[0].className == "active") {
            console.log("parent is active");
            $(this)
                .parent()
                .removeClass("active")
                .find("button")
                .attr("aria-expanded", false);
        } else {
            $(".mobile-menu-popout .mobile-menu-item")
                .parent()
                .removeClass("active")
                .find("button")
                .attr("aria-expanded", false);
            $(this)
                .parent()
                .addClass("active")
                .find("button")
                .attr("aria-expanded", true);
        }
    });
    $("#open-mobile-menu").on("click", function() {
        $(".mobile-menu-popout").toggleClass("open");
    });

    // On Hover
    $(".menu-item a").hover(function() {
        if($(this).hasClass("megamenu-toggle")) {
            $(".megamenu-lightbox-bg").fadeIn(200)
        }
        // Reset states of all megamenus on hover of menu item
        $(".megamenu")
            .removeClass("open --has-background")
            .css("background-image", "none");
        $(".menu-item")
            .parent()
            .removeClass("active")
            .find("a, button")
            .attr("aria-expanded", false);
        $("#inspiration-book-button")
            .attr("aria-expanded", false)
            .parent()
            .removeClass("active");
        // Change aria-expanded state on hover
        $(this).attr("aria-expanded", true);
        var targetMenu = ".megamenu#" + $(this).attr("aria-controls");
        $(targetMenu).addClass("open");
        $(this)
            .parent()
            .addClass("active");
    });
    // On mouse leave of menu item close menu unless you enter the megamenu
    $(".menu-item a").mouseleave(function(e) {
        if (!$(e.relatedTarget).hasClass("megamenu")) {
            $(".megamenu-lightbox-bg").fadeOut(200)
            var targetMenu = ".megamenu#" + $(this).attr("aria-controls");
            $(targetMenu).removeClass("open");
            $(this)
                .parent()
                .removeClass("active");
        }
    });
    // On Megamenu mouse leave
    $(".megamenu").mouseleave(function() {
        $(".megamenu-lightbox-bg").fadeOut(200)
        // Reset states of all megamenus on mouseleave of megamenu

        $(".megamenu")
            .removeClass("open --has-background")
            .css("background-image", "none");
        $(".menu-item")
            .removeClass("active")
            .find("a, button")
            .attr("aria-expanded", false);
        $("#inspiration-book-button")
            .attr("aria-expanded", false)
            .parent()
            .removeClass("active");
    });
    // On hover of children links

    $(".megamenu ul li a").each(function() {
        if ($(this).parent().attr("data-banner")) {
            var img = $(this)
                .parent()
                .attr("data-banner");
            $(".image-preloader").html("<img src='" + img + "' />");
        }
        $(".megamenu ul li a").mouseleave(function() {
            $(".megamenu").css("background-image", "");
            // $(this)
            //     .parent()
            //     .parent()
            //     .parent()
            //     .parent()
            //     .parent()
            //     .parent()
            //     .removeClass("--has-background")
            //     .css("background-image", "");
        })
        $(this).hover(function() {
            var img = $(this)
                .parent()
                .attr("data-banner");
            if (
                $(this)
                    .parent()
                    .attr("data-banner")
            ) {
                $(this)
                    .parent()
                    .parent()
                    .parent()
                    .parent()
                    .parent()
                    .parent()
                    .addClass("--has-background")
                    .css("background-image", "url(" + img + ")");
            }
        });
    });
    $(".open-search").on("click", function() {
        $("#search-dialog").fadeIn();
        $("#search-dialog .site-search").focus();
        $(".mobile-menu-popout").removeClass("open");
    });
    $("#close-search").on("click", function() {
        $("#search-dialog").fadeOut();
    });

    // Inspiration book

    $("#inspiration-book-button").on("click", function() {
        // Aria expanded toggle
        if ($(this).attr("aria-expanded") == "false") {
            $(this).attr("aria-expanded", true);
        } else {
            $(this).attr("aria-expanded", false);
        }
        $(this)
            .parent()
            .toggleClass("active");
        $("#inspiration-book-megamenu").toggleClass("open");
    });
})();
